import { render, staticRenderFns } from "./SnListModel.vue?vue&type=template&id=adb2606c&scoped=true"
import script from "./SnListModel.vue?vue&type=script&lang=js"
export * from "./SnListModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adb2606c",
  null
  
)

export default component.exports